import React from 'react';

import { BlockOutlined } from '@ant-design/icons';
import { Row, Col } from 'antd';
import { OriginValuePopover } from './OriginValuePopover';

//! deprecated
// import { useCompareOverlayAndOriginValue, useOverlayValue } from './hooks';

import classnames from 'classnames';

import './OverlayInputWrapper.less';

const OverlayInputWrapper = (props) => {
  const {
    children, //* input render
    value,
    valuePropName = 'value',
    noWrapper,
    originValue,
    originValueRenderFn,
    showOverlay = true,
    checkShowOverlayFn,
    style = {},
    wrapperStyle = {},
    ...restProps
  } = props;

  const inputValue = props?.[valuePropName];

  const renderChildren = () => {
    return children
      ? React.Children.map(children, (child) => {
          return React.cloneElement(child, {
            [valuePropName]: inputValue,
            ...restProps,
            ...child.props,
          });
        })
      : null;
  };

  const isShowOverlay = checkShowOverlayFn
    ? checkShowOverlayFn({ value })
    : showOverlay;

  const originValueRender = originValueRenderFn
    ? originValueRenderFn()
    : originValue;

  return (
    <div
      className={classnames({ 'form-item-overlay__border': isShowOverlay })}
      style={wrapperStyle}
    >
      <Row>
        <Col style={{ flex: 1, ...style }}>{renderChildren()}</Col>
        {isShowOverlay && (
          <Col style={{ display: 'flex', alignItems: 'center' }}>
            <OverlayMark originValueRender={originValueRender} />
          </Col>
        )}
      </Row>
    </div>
  );
};

const OverlayMark = ({ originValueRender }) => {
  return (
    <div className='form-item-overlay__mark'>
      <OriginValuePopover
        originValueRender={originValueRender}
        showHighlight={false}
      >
        <BlockOutlined />
      </OriginValuePopover>
    </div>
  );
};

export default OverlayInputWrapper;
